import $ from 'jquery';
import {forEach} from 'lodash';
import Backbone from 'backbone';
import {logPageview} from '@sinclair-digital/stl-common/src/analytics/common';
import PropertySectionPreviewView from './views/properties/propertySectionPreviewView';
import PropertyListView from './views/properties/propertyListView';
import ControllerView from './views/controllerView';
import MediaListView from './views/media/mediaListView';
import SiteTreeView from './views/properties/siteTreeView';
import PageNotFoundView from './views/pageNotFoundView';
import AdminView from './views/admin/adminView';

const _staticRoutes = {
    // Properties
    'property(/)': '_propertyListRender',
    'property/:id/:sectionId/preview': '_propertySectionPreviewRender',
    'property/:id': '_propertyTreeRender',

    // Media
    'media(/)': '_mediaRender',
    'media/upload': '_mediaUploadRender',
    'media/:id': '_mediaRender',

    // Admin
    'admin(/)': '_adminRender',

    // Other
    'settings(/)': '_settingsRender',

    // MUST BE LAST
    '*actions': '_pageNotFoundAction',
};

export default Backbone.Router.extend({
    routes: _staticRoutes,
    initialize({routeOverrides, userModel, appContext}) {
        forEach(routeOverrides, this.registerRoute.bind(this));
        this.userModel = userModel;
        this.appContext = appContext;
        this.controllerView = new ControllerView();
        this.bind('route', this.pageView);
        this.controllerView.renderShell(userModel, appContext);
    },
    _modules: {},
    registerRoute({route, title, showNav, module = this._modules[name]}) {
        this._modules[title] = module;
        this.route(
            route,
            this._showSimpleView.bind(this, {
                title,
                viewClass: module[route] || module.route || module,
                showNav,
            }),
        );
    },
    _controller(opts) {
        this.controllerView.render({
            ...opts,
            userModel: this.userModel,
            appContext: this.appContext,
        });
    },
    _showSimpleView(opts = {}, ...params) {
        if (opts.showNav !== undefined) {
            (opts.showNav ? this._showNavPanel : this._hideNavPanel)();
        }

        return this._controller({params, ...opts});
    },

    // Property
    _propertyListRender() {
        return this._showSimpleView({
            showNav: true,
            viewClass: PropertyListView,
            title: 'Properties',
        });
    },
    _propertySectionPreviewRender(id, sectionId) {
        return this._showSimpleView({
            showNav: false,
            viewClass: PropertySectionPreviewView,
            title: 'Property Preview',
            id,
            sectionId,
        });
    },
    _propertyTreeRender(id) {
        return this._showSimpleView({
            showNav: false,
            viewClass: SiteTreeView,
            title: 'Edit Property',
            id,
        });
    },

    // Media
    _mediaRender() {
        return this._showSimpleView({
            showNav: true,
            viewClass: MediaListView,
            title: 'Media',
            upload: false,
        });
    },
    _mediaUploadRender() {
        return this._showSimpleView({
            showNav: true,
            viewClass: MediaListView,
            title: 'Media Upload',
            upload: true,
        });
    },

    // Admin
    _adminRender() {
        this._controller({
            viewClass: AdminView,
            title: 'Admin',
        });
    },

    _pageNotFoundAction() {
        return this._showSimpleView({
            showNav: true,
            viewClass: PageNotFoundView,
            title: 'Page not found',
        });
    },

    // TODO move this to ControllerView
    _hideNavPanel() {
        $('body').addClass('hide-nav');
        $('.sda-nav-panel').removeClass('panel-open');
    },
    _showNavPanel() {
        $('body').removeClass('hide-nav');
        $('.sda-nav-panel').addClass('panel-open');
    },
    pageView() {
        // merge duplicate query params intermittely caused auth0 redirect
        const _url = new URL(window.location.href);
        let search = _url.search;
        const hash = _url.hash.replace(/\?.+$/, '');
        const matches = _url.href.match(/\?([^#?]+)/g);
        if (matches) {
            search = '?' + matches.map(match => match.replace(/^\?/, '')).join('&');
        }
        window.history.replaceState(null, '', `/${hash}${search}`);

        const url = Backbone.history.getFragment();
        // google analytics
        logPageview({page: '#' + url, title: window.title});
    },
});
